
export default {
  name: "BookingIndex"
}
